import { useSearchParams } from "react-router-dom";
import { loadScript } from "@utils/general";
import { Grid, CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";

export const PaymentModalInvoiceUnbound = () => {
	const [searchParams] = useSearchParams();
	const [isLoadingCheckout, setIsLoadingCheckout] = useState(false);
	const [loaded, setLoaded] = useState<boolean>(false);
	const [iframeLoaded, setIframeLoaded] = useState(false);
	const allowedPaymentMethods: string[] = [];

	useEffect(() => {
		loadScript("https://cdn.paddle.com/paddle/v2/paddle.js", () => {
			setupPaddle();
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	const setupPaddle = () => {
		const paddle = (window as any).Paddle;

		if (import.meta.env.VITE_REACT_APP_PADDLE_SANDBOX == 1) {
			paddle.Environment.set("sandbox");
		}

		const paddleToken = import.meta.env.VITE_REACT_APP_PADDLE_CLIENT_TOKEN;

		paddle.Initialize({
			token: paddleToken,

			checkout: {
				settings: {
					displayMode: "overlay",
					frameStyle:
						"width:100%; min-width:312px; background-color: transparent; border: none;", // Please ensure the minimum width is kept at or above 286px with checkout padding disabled, or 312px with checkout padding enabled. See "General" section under "Branded Inline Checkout" below for more information on checkout padding.
					frameInitialHeight: 416,
					allowLogout: false,
					frameTarget: "paddle-checkout", // The className of your checkout <div>,
					allowedPaymentMethods,
				},
			},
		});
		setLoaded(true);
	};
	useEffect(() => {
		console.log("tx", loaded, searchParams.get("_ptxn"));
		const openPaddleCheckout = async () => {
			setIsLoadingCheckout(true);
			const paddle = (window as any).Paddle;

			paddle.Checkout.open({ transactionId: searchParams.get("_ptxn") });
			setIsLoadingCheckout(false);
		};

		if (loaded) {
			openPaddleCheckout();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [loaded]);

	useEffect(() => {
		const checkIframeLoaded = setInterval(() => {
			const paddleFrame = document.querySelector('iframe[name="paddle_frame"]');
			if (paddleFrame) {
				setIframeLoaded(true);
				clearInterval(checkIframeLoaded);
			}
		}, 100);

		return () => clearInterval(checkIframeLoaded);
	}, [loaded]);

	if (isLoadingCheckout) return <></>;
	return (
		<Grid container direction="column" alignItems="center" spacing={2}>
			{!iframeLoaded && (
				<Grid item>
					<CircularProgress />
				</Grid>
			)}
			<Grid item style={{ width: "100%" }}>
				<div className="paddle-checkout" />
			</Grid>
		</Grid>
	);
};
